import React from 'react';
import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import { ROUTE_TREE } from 'routes/AppRoutes';
import HomeIcon from '@mui/icons-material/Home';

// interface MessageProps {
//     message: string;
// }

function NotFoundComponent(){
    const navigate = useNavigate();

    return (
        <Box sx={{ 
            p: 4, 
            bgcolor: 'background.default', 
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Card sx={{ bgcolor: 'background.paper', boxShadow: 4, maxWidth: 500, width: '100%' }}>
                <CardContent sx={{ p: 6, textAlign: 'center' }}>
                    <Typography variant="bglTitle1" component="h1" sx={{ mb: 2 }}>
                        404
                    </Typography>
                    <Typography variant="bglTitle3" sx={{ mb: 2 }}>
                        Page Not Found
                    </Typography>
                    <Typography variant="bglBody2" color="text.secondary" sx={{ mb: 4 }}>
                        The page you're looking for doesn't exist or has been moved.
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<HomeIcon />}
                        onClick={() => navigate(ROUTE_TREE.ROOT.path)}
                        sx={{ minWidth: 200 }}
                    >
                        Go Home
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
};

export default NotFoundComponent;